import JwtDecode from 'jwt-decode';
import { getImageUrl } from 'src/utils/cdn';

export function decodeJwtToken(token) {
  if (!token) {
    return {};
  }
  try {
    return JwtDecode(token);
  } catch (e) {
    return {};
  }
}

export function getUserName(user) {
  if (Object.keys(user).length === 0) {
    return '';
  }

  let userName = user.mb_name;

  if (user.user && user.user.name_eng) {
    userName += `(${user.user.name_eng})`;
  }

  return userName;
}

export function getUserKorName(user) {
  if (Object.keys(user).length === 0) {
    return '';
  }

  let userName = user.mb_name;

  return userName;
}

const Avatars = [
  getImageUrl('common/avatar_1.png'),
  getImageUrl('common/avatar_2.png'),
  getImageUrl('common/avatar_3.png'),
  getImageUrl('common/avatar_4.png'),
  getImageUrl('common/avatar_5.png'),
];

export function getUserAvatarSrc(user) {
  if (Object.keys(user).length === 0 || !user.user_point) {
    return Avatars[0];
  }

  const { point } = user.user_point;

  if (point < 501) {
    return Avatars[0];
  } else if (point < 5001) {
    return Avatars[1];
  } else if (point < 15001) {
    return Avatars[2];
  } else if (point < 30001) {
    return Avatars[3];
  } else {
    return Avatars[4];
  }
}

export function getUserAvatarType(user) {
  if (Object.keys(user).length === 0 || !user.user_point) {
    return Avatars[0];
  }

  const { point } = user.user_point;

  if (point < 501) {
    return 1;
  } else if (point < 5001) {
    return 2;
  } else if (point < 15001) {
    return 3;
  } else if (point < 30001) {
    return 4;
  } else {
    return 5;
  }
}
